import React, { FC, memo } from 'react'
import { FormProps, Form } from 'antd'
import renderFormElement, { JsonSchema } from './DslSchemaInterpretor'

export type Schema = JsonSchema

type SchemaFormProps = FormProps & { schema: JsonSchema }

const SchemaForm: FC<SchemaFormProps> = props => {
  return (
    <Form {...props}>
      {renderFormElement(props.schema)} {props.children}
    </Form>
  )
}

export default memo(SchemaForm)
